import axios from "axios";

// Fetch USDT Price & 24h Change from CoinGecko
export async function getUSDTPrice() {
  const url =
    "https://api.coingecko.com/api/v3/simple/price?ids=tether,usd-coin&vs_currencies=usd&include_24hr_change=true";
  const { data } = await axios.get(url);
  return {
    USDT: {
      priceUsd: data.tether.usd,
      priceChange24h: data.tether.usd_24h_change,
      value: data.tether.usd,
    },
    USDC: {
      priceUsd: data["usd-coin"].usd,
      priceChange24h: data["usd-coin"].usd_24h_change,
      value: data["usd-coin"].usd,
    },
  };
}
